module.exports = __webpack_public_path__ + "static/wedding-brochure-7b7046055f7ca8c930521998d9b7dd9b.pdf";